module.exports = __webpack_public_path__ + "img/map_Z3.1.A.01.4123c587.svg";